<template>
  <div class="image-loader">
    <indicator v-show="indicator && isLoading"></indicator>
    <div v-show="!isLoading">
      <div v-if="link !== ''">
        <a :href="link">
          <img :src="src" :width="width" :height="height" @load="isLoaded" @error="loadingError" />
        </a>
      </div>
      <div v-else>
        <img :src="src" :width="width" :height="height" @load="isLoaded" @error="loadingError" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    src: {
      required: true,
      type: String,
    },
    link: String,
    ratio: {
      type: String,
      default: 'auto'
    },
    width: {
      type: Number,
      default: 'auto'
    },
    height: {
      type: Number,
      default: 'auto'
    },
    type: String,
    indicator: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isLoading: true
    }
  },
  mounted() {
    console.log('Vue/components/image-loader/mounted');
  },
  methods: {
    isLoaded() {
      console.log('Vue/components/image-loader/loaded');
      this.isLoading = false;
    },
    loadingError() {
      console.log('Vue/components/image-loader/error');
    }
  }
}
</script>

<style scoped>
/* Add any scoped styles specific to the component here */
</style>
